import { render, staticRenderFns } from "./zhengji.vue?vue&type=template&id=62c0166b&scoped=true&"
import script from "./zhengji.vue?vue&type=script&lang=js&"
export * from "./zhengji.vue?vue&type=script&lang=js&"
import style0 from "./zhengji.vue?vue&type=style&index=0&id=62c0166b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0166b",
  null
  
)

export default component.exports